import { render } from "./BarterFrom.vue?vue&type=template&id=175bdc3c"
import script from "./BarterFrom.vue?vue&type=script&lang=js"
export * from "./BarterFrom.vue?vue&type=script&lang=js"

import "./BarterFrom.vue?vue&type=style&index=0&id=175bdc3c&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__